import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
import { EmailSignUpFloaterBar } from '../EmailSignUpFloaterBar';
import { isBrowser } from '@jelly/utils';
import { SiteConfigContext } from '../SiteConfigProvider';
export var EmailSubscribeContext = /*#__PURE__*/React.createContext();
/**
 * This provider wraps the root of both BDC and BND
 * It provides context to handle the logic for the email capture floater bar as well as the subscribe button
 */

export function EmailSubscribeProvider(_ref) {
  var children = _ref.children;
  var defaultEmailFormSubmissionState = false;

  var _useState = useState(function () {
    try {
      if (isBrowser()) {
        var item = window.sessionStorage.getItem('emailSubscriptionEnabled'); // Parse stored json or if none return defaultEmailFormSubmissionState

        return item ? JSON.parse(item) : defaultEmailFormSubmissionState;
      } else {
        return defaultEmailFormSubmissionState;
      }
    } catch (error) {
      // If error also return defaultEmailFormSubmissionState
      console.error('sessionstorage', error);
      return defaultEmailFormSubmissionState;
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      emailSubscribeFormSubmitted = _useState2[0],
      setEmailSubscribeFormSubmitted = _useState2[1];

  var _useContext = useContext(SiteConfigContext),
      homepage = _useContext.siteConstants.EMAIL_CAPTURE_SOURCES.homepage;

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      emailSubscribeSource = _useState4[0],
      setEmailSubscribeSource = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isVisible = _useState6[0],
      setIsVisible = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isScrollListenerEnabled = _useState8[0],
      setIsScrollListenerEnabled = _useState8[1]; // defaulting to false here because we only want to enable floater bar to show up on scroll for homepage, articles with no widget, and hubs with no sponsor


  return /*#__PURE__*/React.createElement(EmailSubscribeContext.Provider, {
    value: {
      emailSubscribeSource: emailSubscribeSource,
      emailSubscribeFormSubmitted: emailSubscribeFormSubmitted,
      isVisible: isVisible,
      isScrollListenerEnabled: isScrollListenerEnabled,
      setEmailSubscribeFormSubmitted: setEmailSubscribeFormSubmitted,
      setEmailSubscribeSource: setEmailSubscribeSource,
      setIsVisible: setIsVisible,
      setIsScrollListenerEnabled: setIsScrollListenerEnabled
    }
  }, children, /*#__PURE__*/React.createElement(EmailSignUpFloaterBar, {
    source: emailSubscribeSource
  }));
}